import "./NX5_MonitorVitalDataMobileView.scss";
import monitorOfflineIcon from "../../common/icons/svg/patient-monitor-offline.svg";
import { MONITOR_PARAMETER } from "../../common/constant/common-constants";
import DevicesTab from "../../container/PatientRightPanel/MachineTabs/DevicesTab.jsx";
import MonitorChart from "../MonitorChart/MonitorChart";


const NX5_MonitorVitalDataMobileView = ({ props }) => {

    if (!props?.monitorHeartBeatData?.isConnected) {
        return (
            <div className="offline-mobile-view">
                <img
                    className="not-in-use-image-mobile-view"
                    src={monitorOfflineIcon}
                    alt="Monitor Offline"
                />
                <h2 className="not-in-use-text-mobile-view">
                    Monitor is currently offline, possibly due to settings or poor internet connection; please check and ensure proper configuration for seamless monitoring.
                </h2>
            </div>
        );
    }

    const hr = props.vitalData_ECG?.[MONITOR_PARAMETER.HR];
    const rr = props.vitalData_ECG?.[MONITOR_PARAMETER.RR];
    const spo2 = props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2];
    const pr = props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2_PULSE_RATE];
    const temp1 = props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_1];
    const temp2 = props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_2];
    const nibpSys = props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_SYSTOLIC];
    const nibpDia = props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_DIASTOLIC];
    const nibpMean = props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_MEAN];

    const renderLimits = (paramData) => {
        const high = paramData?.alarm_limit?.[1] ?? "-";
        const low = paramData?.alarm_limit?.[0] ?? "-";
        return (
            <div className="nx5-vital-tile-limits">
                <span>{high}</span>
                <span>/</span>
                <span>{low}</span>
            </div>
        );
    };

    return (
        <div className="nx5-monitor-vitals-container-mobile-view">
            <div className="nx5-monitor-vitals-mobile-view-alarms">
                <DevicesTab
                    activeVitalDevice={props.activeVitalDevice}
                    bedId={props.bedId}
                    alarmData={props.alarmData}
                    handleSeeAllAlarms={props.handleSeeAllAlarms}
                />
            </div>

            {!props.monitoringVitalsView ? (
                <div className="nx5-monitor-vitals-mobile-view-graphs">
                    <MonitorChart bedId={props.bedId} />
                </div>
            ) : (

                <div className="nx5-monitor-vitals-mobile-view-body">
                    <div className="nx5-vital-tile-row">
                        <div className="nx5-vital-tile nx5-tile-hr">
                            <div className="nx5-vital-tile-header">
                                <span className="nx5-vital-tile-label">HR</span>
                                <span className="nx5-vital-tile-unit">beats/min</span>
                            </div>
                            <div className="nx5-vital-tile-value">{hr?.value ?? "-"}</div>
                            {renderLimits(hr)}
                        </div>

                        <div className="nx5-vital-tile nx5-tile-pr">
                            <div className="nx5-vital-tile-header">
                                <span className="nx5-vital-tile-label">PR</span>
                                <span className="nx5-vital-tile-unit">beats/min</span>
                            </div>
                            <div className="nx5-vital-tile-value">{pr?.value ?? "-"}</div>
                            {renderLimits(pr)}
                        </div>
                    </div>

                    <div className="nx5-vital-tile-row">
                        <div className="nx5-vital-tile nx5-tile-rr">
                            <div className="nx5-vital-tile-header">
                                <span className="nx5-vital-tile-label">RR</span>
                                <span className="nx5-vital-tile-unit">b/min</span>
                            </div>
                            <div className="nx5-vital-tile-value">{rr?.value ?? "-"}</div>
                            {renderLimits(rr)}
                        </div>

                        <div className="nx5-vital-tile nx5-tile-spo2">
                            <div className="nx5-vital-tile-header">
                                <span className="nx5-vital-tile-label">SPO2</span>
                                <span className="nx5-vital-tile-unit">%</span>
                            </div>
                            <div className="nx5-vital-tile-value">{spo2?.value ?? "-"}</div>
                            {renderLimits(spo2)}
                        </div>
                    </div>

                    <div className="nx5-vital-tile-row">
                        <div className="nx5-vital-tile nx5-tile-temp">
                            <div className="nx5-vital-tile-header">
                                <span className="nx5-vital-tile-label">TEMP</span>
                                <span className="nx5-vital-tile-unit">°c</span>
                            </div>
                            <div className="nx5-vital-tile-value">
                                {temp1?.value != null ? temp1.value.toFixed(1) : "- -"}
                                {temp2?.value != null ? ` / ${temp2.value.toFixed(1)}` : "/- -"}
                            </div>
                            <div className="nx5-vital-tile-limits">
                                <span>T1</span>
                                <span>/</span>
                                <span>T2</span>
                            </div>
                        </div>

                        <div className="nx5-vital-tile nx5-tile-nibp">
                            <div className="nx5-vital-tile-header">
                                <span className="nx5-vital-tile-label">NIBP</span>
                                <span className="nx5-vital-tile-unit">mmHg</span>
                            </div>
                            <div className="nx5-vital-tile-value">
                                {`${nibpSys?.value ?? "- -"}/${nibpDia?.value ?? "- -"}`}
                            </div>
                            <div className="nx5-vital-tile-limits">
                                <span>({nibpMean?.value ?? "-"})</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            </div>
    );
};

export default NX5_MonitorVitalDataMobileView;
